// Reimbursements (facilitator/admin only): a simple link-out to the
// third-party expense-report tool our accounting team hosts. We do not
// rebuild the form or integrate with Bill.com here — this page just makes it
// reachable from inside the app.

import { Receipt, ExternalLink } from 'lucide-react';

const EXPENSE_REPORT_TOOL_URL =
  'https://script.google.com/macros/s/AKfycbwLoMUn9VPOoWBlGWhd_4DQf6wWpZjOlUD77lzi2dC17nn4-t98HgD3dgZmr_sCI1sGEQ/exec';

export default function Reimbursements() {
  return (
    <div className="space-y-6 max-w-2xl">
      <div>
        <h1 className="text-2xl font-bold text-navy flex items-center gap-2">
          <Receipt size={26} />
          Reimbursements
        </h1>
        <p className="text-gray-500 mt-1">
          Submit your Iron Forums expense receipts for reimbursement using our
          accounting team's expense report tool.
        </p>
      </div>

      <div className="bg-white rounded-2xl p-6 shadow-sm">
        <p className="text-gray-700">
          Our outsourced accounting team handles expense reimbursements
          through a dedicated tool outside of Iron Forums. Click below to
          open it in a new tab and submit your receipts.
        </p>
        <a
          href={EXPENSE_REPORT_TOOL_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="mt-4 inline-flex items-center gap-2 px-5 py-3 bg-gold text-white rounded-lg font-medium hover:bg-gold-dark transition"
        >
          Open Expense Report Tool
          <ExternalLink size={18} />
        </a>
      </div>
    </div>
  );
}
